import React, { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';

import { Select } from 'uiToolkitV1/Select';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { ViewEditInitiativesTable } from './Subtables/ViewEditInitiativesTable';
import { ViewEditKeyResultsTable } from './Subtables/ViewEditKeyResultsTable';
import { ViewEditObjectivesTable } from './Subtables/ViewEditObjectivesTable';

interface Props {}

const VIEW_EDIT_TABS = [
  {
    label: 'Objectives',
    value: 'objectives',
    Comp: ViewEditObjectivesTable,
  },
  {
    label: 'Key Results',
    value: 'keyResults',
    Comp: ViewEditKeyResultsTable,
  },
  {
    label: 'Initiatives',
    value: 'initiatives',
    Comp: ViewEditInitiativesTable,
  },
];

const ViewEditTable = (props: Props) => {
  const [selectedTab, setSelectedTab] = useState(VIEW_EDIT_TABS[0]);

  const { Comp } = selectedTab ?? {};

  return (
    <Flex flexDir="column">
      <Flex padding="8px 12px" mt="12px">
        <TextBodyMedium minW="160px" bold color="text.g3">
          View & Edit Access for:
        </TextBodyMedium>
        {/* @ts-ignore */}
        <Select options={VIEW_EDIT_TABS} value={selectedTab} handleChange={(value) => setSelectedTab(value)} />
      </Flex>
      <Box p={0} mt="20px">
        <Comp />
      </Box>
    </Flex>
  );
};

export { ViewEditTable };
